import { render, staticRenderFns } from "./SettingDoctorSayInfo.vue?vue&type=template&id=b805363c&scoped=true&"
import script from "./SettingDoctorSayInfo.vue?vue&type=script&lang=js&"
export * from "./SettingDoctorSayInfo.vue?vue&type=script&lang=js&"
import style0 from "./SettingDoctorSayInfo.vue?vue&type=style&index=0&id=b805363c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b805363c",
  null
  
)

export default component.exports